import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { RewardsWalletService } from '@fgb/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-marketplace-wallet-page',
  templateUrl: './marketplace-wallet-page.component.html',
  styleUrls: ['./marketplace-wallet-page.component.scss'],
})
export class MarketplaceWalletPageComponent implements OnInit {
  constructor(private location: Location, private route: ActivatedRoute, private rewardsWalletService: RewardsWalletService) {}

  goBack() {
    this.location.back();
  }
  id: string;

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id') || '0';
    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
  }
}
